import { FieldQualifierValue } from './getCqlFieldQualifierValue';
import { fieldsToMaskMap, searchQualifierMaskMap } from '../constants';

export const getMaskedQuery = ({
  field,
  qualifier,
  value,
}: FieldQualifierValue): string => {
  return `${fieldsToMaskMap[field]} ${searchQualifierMaskMap[qualifier]} "${value}"`;
};
